module.exports = __webpack_public_path__ + "img/banner-m.815322c8.png";